import React from "react"

// import Div from '../layouts/Div'
import Backend from '../../../utils/Backend'
import Notify from "../../../utils/Notify";

export default class FileUploader extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      file: props.file,
      params: props.params,
      endpoint: props.endpoint,
      placeholder: props.placeholder
    }

    this.input = React.createRef()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _onFileChange(e) {
    let {
      endpoint,
      params
    } = this.state

    var files = e.target.files;
    var filesArr = Array.prototype.slice.call(files);
    let file = filesArr[0]
    if(file == null){
      return
    }

    if(this.props.maxSize && file.size > this.props.maxSize){
      this.input.current.value = ""
      Notify.error("File size is too large, please upload a file less than "+this.props.maxSizeLabel)
      return
    }

    this.setState({ loading: true })
    this.props.onUploading()
    if(!this.props.canUpload){
      return
    }
    Backend.uploadFile(file, endpoint, params)
      .then(file => {
        this.setState({
          file,
          loading: false
        })
        this.props.onUploaded(file)
      })
      .catch(error => {
        this.setState({ loading: false })
        alert(error.message)
      })

  }

  render() {

    let {
      file,
      loading,
      placeholder
    } = this.state

    let filename = file?.name || file?.original
    let label = filename || placeholder
    return (
      <>
        <div className="input-group">
          <div className="custom-file">
            <input
              type="file"
              ref={this.input}
              className="custom-file-input"
              accept={this.props.accept}
              onChange={e => this._onFileChange(e)}
            />
          </div>
        </div>
      </>
    )
  }
}


FileUploader.defaultProps = {
  canUpload: true,
  className: "",
  placeholder: "Choose file"
}
